// components/auth/AuthHeroBit.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const AuthHeroBit = ({ title, subtitle }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <section ref={ref} className="py-16 bg-gradient-to-b from-ivory to-nude-beige">
            <div className="container mx-auto px-6 lg:px-12">
                <motion.div
                    initial={{ y: 40, opacity: 0 }}
                    animate={isInView ? { y: 0, opacity: 1 } : {}}
                    transition={{ duration: 1 }}
                    className="max-w-3xl mx-auto text-center"
                >
                    <div className="mb-8">
                        <svg className="w-16 h-16 mx-auto text-sage-green mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        <h1 className="font-playfair text-4xl md:text-5xl text-charcoal mb-4">
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="font-poppins text-xl text-charcoal/70">
                                {subtitle}
                            </p>
                        )}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default AuthHeroBit;